import React from "react";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navClass: ""
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    if (window.pageYOffset > 600) {
      this.setState({
        navClass: "scroll"
      });
    } else {
      this.setState({
        navClass: ""
      });
    }
  }

  render() {
    return (
      <nav
        className={
          "navbar navbar-default navbar-expand-lg fixed-top " +
          this.state.navClass
        }
      >
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="icon ios-arrow-up"></span>
        </button>
        <div className="nav-logo-mobile">
          <img src="images/logo_shopee_v.png" alt="Shopee Logo" />
          {/* <h1 className="logo-text">Best<br />Coder<br />Challenge</h1> */}
        </div>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="container">
            <a className="nav-logo-desktop" href="/">
              <img src="images/logo_shopee_h.png" alt="Shopee Logo" />
              {/* <h1 className="logo-text">Best<br />Coder<br />Challenge</h1> */}
            </a>
            <ul
              className="navbar-nav ml-auto"
              data-easing="easeInOutExpo"
              data-speed="1250"
              data-offset="65"
            >
              <li className="nav-item">
                <a className="nav-link" href="#about">
                  About
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link" href="#categories">
                  Categories
                </a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link" href="#prizes">
                  Prizes
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#timeline">
                  Timeline
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#training">
                  Training Workshops
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#faq">
                  FAQ
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#partners">
                  Partners
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#gallery">
                  Past Events
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="https://careers.shopee.sg/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Career
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
export default Navbar;
